import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AuthGuard } from './share/security/auth-guard';
import { AppRoutingModule } from './share/app-routing.module';
import { AuthInterceptor } from './share/security/auth-interceptor';
import { AppComponent } from './app.component';
import { LoginComponent } from './share/login/login.component';
import { HeaderComponent } from './share/header/header.component';
import { AuthenticationService } from './share/security/authentication.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  }, AuthenticationService, AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/Anders/workspace/DOFBasenCli/src/app/app.module.ts